import React, { useEffect, useState } from "react";
import UploadSvg from "../../components/svg/UploadSvg";
import "react-toastify/dist/ReactToastify.css";
import { toast, ToastContainer } from "react-toastify";

import config from "../../config";
import { useNavigate, useParams } from "react-router-dom";

const BASE_URL = config.base_url;

const UploadJobFiles = () => {
  const { id } = useParams();
    const navigate = useNavigate();
  const [job, setJob] = useState(null);
  const [isUploading, setIsUploading] = useState(false);



  const applicationFormUrl = job
    ? `${BASE_URL}api/download/application-form/${job?.application_form}`
    : "";

  const [formData, setFormData] = useState({
    resume: "",
    applicationForm: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    // validation
    if (!formData?.resume || !formData?.applicationForm) {
      toast.warning("Both Resume and Application Form are required");
      return;
    }

    // submit to backend.
    try {
        setIsUploading(true);
         const payload = new FormData();
         payload.append('application_form', formData?.applicationForm);
         payload.append('resume', formData?.resume);
         payload.append('job_id', +id);

        
      const response = await fetch(`${BASE_URL}api/send-applicant-details`, {
        method: "POST",
        body: payload,
  
      });
      const data = await response.json();

      if (data?.errors) {
        if (typeof data.errors === "object" && data.errors !== null) {
          const [key, value] = Object.entries(data.errors)[0];

          throw new Error(
            `${key} - ${Array.isArray(value) ? value.join(", ") : value}`,
          );
        }

        throw new Error(String(data.errors));
      }
      if(data?.status === 200) {
        navigate("/thankyou?s=career");
        return;
      }
    } catch (error) {
      console.log(error);
      toast.error(
        error?.message ||
          "Unable to send your details. Please try again later....",
      );
      return;
    }finally {
        setIsUploading(false);
    }
  };



  useEffect(() => {
    const fetchJob = async () => {
      try {
        const url = `${BASE_URL}api/get-job/id/${id}`;
        const response = await fetch(url);
        const data = await response.json();
        setJob(data?.job);
      } catch (error) {
        console.log(error, "error");
      }
    };
    fetchJob();
  }, []);

  return (
    <div className="container py-5">
      <form onSubmit={handleSubmit}>
        <div className="text-center mb-5">
          <h2 className="fw-semibold">JOB APPLICATION FORM</h2>
        </div>

        <div className="row justify-content-center gap-4">
          {/* Resume Upload */}
          <div className="col-md-5 ">
            <div className="upload-box text-center p-4 py-5">
              <div className="upload-icon mb-4">
                <UploadSvg />
              </div>

              <h6 className="mt-2 mb-1">Upload Your Resume</h6>
              <small className="text-muted">(up to 3MB)</small>

              <div className="mt-4 rounded-5">
                <input
                  type="file"
                  id="resume"
                  hidden
                    accept=".pdf,.doc,.docx"
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      resume: e.target.files[0],
                    }))
                  }
                />

                <label
                  htmlFor="resume"
                  className="btn choose-btn text-white rounded-pill "
                >
                  Choose File
                </label>

                {formData?.resume && (
                  <p className="mt-2 small text-success">
                    {formData?.resume.name}
                  </p>
                )}
              </div>
            </div>
          </div>

          {/* Application Form Upload */}
          <div className="col-md-5 ">
            <div className="upload-box text-center p-4 py-5">
              <div className="upload-icon mb-4">
                <UploadSvg />
              </div>

              <h6 className="mt-2 mb-1">Upload Your Application</h6>
              <small className="text-muted">(up to 3MB)</small>

              <div className="mt-4">
                <input
                  type="file"
                  id="application"
                  hidden
                  accept=".pdf,.doc,.docx"
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      applicationForm: e.target.files[0],
                    }))
                  }
                />

                <label
                  htmlFor="application"
                  className="btn choose-btn text-white rounded-pill "
                >
                  Choose File
                </label>

                {formData?.applicationForm && (
                  <p className="mt-2 small text-success">
                    {formData?.applicationForm.name}
                  </p>
                )}
              </div>
            </div>

            <div className="text-center my-2">
              <small>
                Don’t have an Application?, &nbsp;
                <a
                href={applicationFormUrl}
                target="_block"
                download
                 >
                  Download here
                </a>
              </small>
            </div>
          </div>
        </div>

        <div className="text-center mt-5">
          <button className="btn btn-primary px-5" disabled={isUploading}>
             {
                isUploading ? "Submitting..." : "Submit"
             }
            </button>
        </div>
        <ToastContainer />
      </form>
    </div>
  );
};

export default UploadJobFiles;
